import { render, staticRenderFns } from "./file-item.vue?vue&type=template&id=35f4f9dc&scoped=true&"
import script from "./file-item.vue?vue&type=script&lang=ts&"
export * from "./file-item.vue?vue&type=script&lang=ts&"
import style0 from "./file-item.vue?vue&type=style&index=0&id=35f4f9dc&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35f4f9dc",
  null
  
)

export default component.exports